import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AnalyticsContext from '../../../../../../analyticsContext'

import { getMappedStatisticBySections, getMappedStatisticByRewards } from './utils'

import Tabs from './components/Tabs/Tabs'
import HeaderTip from './components/HeaderTip/HeaderTip'
import Block from './components/Block/Block'

import styles from './Statistics.module.scss'

const TABS = {
    SECTIONS: 'SECTIONS',
    REWARDS: 'REWARDS',
}

const Statistics = ({ statistic, blockProjection }) => {
    const { t } = useTranslation()
    const {
        projectProjection: { rewards: rewardsProjection },
    } = useContext(AnalyticsContext)

    const [activeTabId, setActiveTabId] = useState(() => (!!rewardsProjection ? TABS.REWARDS : TABS.SECTIONS))
    const [tabsList, setTabsList] = useState([])

    const [data, setData] = useState([])

    useEffect(() => {
        if (!!rewardsProjection) {
            setTabsList([
                { id: TABS.REWARDS, label: t('Rewards') },
                { id: TABS.SECTIONS, label: t('Sectors') },
            ])
            return
        }
        setTabsList([])
    }, [rewardsProjection])

    useEffect(() => {
        if (activeTabId === TABS.SECTIONS) {
            const sections = getMappedStatisticBySections(statistic, blockProjection)
            setData(sections)
            return
        }
        if (activeTabId === TABS.REWARDS) {
            const sections = getMappedStatisticByRewards(statistic, rewardsProjection)
            setData(sections)
            return
        }
        setData([])
    }, [statistic, blockProjection, activeTabId])

    const getBlockTitle = section =>
        `${section.resultHeader}${!!section.resultDescription ? ` | ${section.resultDescription}` : ''}`

    return (
        <div className={styles.statistics}>
            <div className={styles.statisticsHeader}>
                <h2 className={styles.statisticsHeaderTitle}>{t('Wheel results')}</h2>
                {!blockProjection.isShowLeadForm && <HeaderTip />}
            </div>

            <Tabs list={tabsList} activeTabId={activeTabId} onChange={tabId => setActiveTabId(tabId)} />

            <div className={styles.statisticsMain}>
                <div className={styles.statisticsMainHeader}>
                    <p className={styles.statisticsMainHeaderTitle}>{t('Results')}</p>
                    <div className={styles.statisticsMainHeaderValues}>{t('Users')}</div>
                </div>
                <ul className={styles.statisticsBlockList}>
                    {data.map(stat => (
                        <Block key={stat.id} title={getBlockTitle(stat)} count={stat.users} percent={stat.percent} />
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Statistics
